var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-container"},[_c('iframe',{ref:"iframe",attrs:{"src":_vm.baseURL,"width":_vm.widowWidth+'px',"height":_vm.windowHeight+'px'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }